/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesAghanimPaymentStatusFromJSON, FxIdDomainEntitiesAghanimPaymentStatusToJSON, } from './FxIdDomainEntitiesAghanimPaymentStatus';
/**
 * Check if a given object implements the FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto interface.
 */
export function instanceOfFxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto(value) {
    if (!('CheckoutUrl' in value) || value['CheckoutUrl'] === undefined)
        return false;
    if (!('Status' in value) || value['Status'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSON(json) {
    return FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSONTyped(json, false);
}
export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'CheckoutUrl': json['CheckoutUrl'],
        'Status': FxIdDomainEntitiesAghanimPaymentStatusFromJSON(json['Status']),
        'AghanimStatus': json['AghanimStatus'] == null ? undefined : json['AghanimStatus'],
    };
}
export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoToJSON(json) {
    return FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoToJSONTyped(json, false);
}
export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'CheckoutUrl': value['CheckoutUrl'],
        'Status': FxIdDomainEntitiesAghanimPaymentStatusToJSON(value['Status']),
        'AghanimStatus': value['AghanimStatus'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto.js.map